
import React from 'react';
import Button from '../../../components/base/Button';

export default function AboutSection() {
  const philosophies = [
    {
      title: 'Tradisi Jepang',
      subtitle: '日本の伝統',
      description: 'Mempertahankan keaslian resep dan teknik memasak tradisional Jepang yang telah diwariskan turun-temurun',
      icon: 'ri-ancient-gate-line',
      color: 'red'
    },
    {
      title: 'Teknologi Futuristik',
      subtitle: '未来技術',
      description: 'Mengintegrasikan teknologi modern dalam pelayanan untuk pengalaman dining yang tak terlupakan',
      icon: 'ri-robot-line',
      color: 'blue'
    },
    {
      title: 'Omotenashi',
      subtitle: 'おもてなし',
      description: 'Filosofi pelayanan Jepang yang mengutamakan ketulusan hati dalam melayani setiap tamu',
      icon: 'ri-heart-line',
      color: 'yellow'
    },
    {
      title: 'Inovasi Rasa',
      subtitle: '味の革新',
      description: 'Berinovasi dalam cita rasa sambil tetap mempertahankan esensi autentik kuliner Jepang',
      icon: 'ri-lightbulb-line',
      color: 'green'
    }
  ];

  const scrollToSection = (sectionId: string) => {
    const element = document.querySelector(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="about" className="py-20 bg-gradient-to-b from-black to-gray-900 dark:from-gray-900 dark:to-gray-800">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl font-black text-white mb-6" style={{ fontFamily: '"Noto Sans JP", serif' }}>
            Tentang <span className="text-red-500">TAKEYA</span>
            <span className="block text-3xl text-yellow-400 mt-2">竹やについて</span>
          </h2>
          <div className="flex items-center justify-center space-x-4 mb-8">
            <div className="h-px w-20 bg-gradient-to-r from-transparent to-red-500"></div>
            <div className="text-yellow-400 text-lg font-bold" style={{ fontFamily: '"Orbitron", sans-serif' }}>
              OUR STORY & PHILOSOPHY
            </div>
            <div className="h-px w-20 bg-gradient-to-l from-transparent to-red-500"></div>
          </div>
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-center mb-20">
          {/* Story Content */}
          <div>
            <h3 className="text-3xl font-bold text-white mb-6">
              Perjalanan Kuliner dari <span className="text-red-400">Jepang ke Bukittinggi</span>
            </h3>
            <div className="space-y-6 text-gray-300 text-lg leading-relaxed">
              <p>
                <strong className="text-yellow-400">TAKEYA (竹や)</strong> lahir dari visi untuk menghadirkan pengalaman kuliner Jepang yang autentik ke jantung Sumatera Barat. Nama "Takeya" yang berarti "rumah bambu" melambangkan fleksibilitas, kekuatan, dan pertumbuhan - nilai-nilai yang kami junjung tinggi.
              </p>
              <p>
                Berlokasi strategis di <strong className="text-red-400">Jl. Raya Bukittinggi - Payakumbuh Jl. Raya Batusangkar No.km 6, Biaro Gadang, Kec. Ampek Angkek, Kabupaten Agam, Sumatera Barat 26152</strong>, kami menghadirkan konsep restoran Jepang futuristik pertama di Bukittinggi.
              </p>
              <p>
                Setiap hidangan kami disiapkan oleh chef berpengalaman yang telah mendalami seni kuliner Jepang selama bertahun-tahun. Kami menggunakan bahan-bahan premium yang diimpor langsung dari Jepang untuk memastikan keaslian rasa.
              </p>
              <p>
                Dengan tagline <strong className="text-yellow-400">"Rasa Autentik Asli Jepang Satu-Satunya di Bukittinggi"</strong>, kami bangga menjadi pionir dalam menghadirkan pengalaman dining Jepang yang tak terlupakan di Minangkabau.
              </p>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              <Button 
                variant="primary" 
                size="lg"
                onClick={() => scrollToSection('#menu')}
                className="shadow-2xl shadow-red-500/50 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-restaurant-line mr-2 w-5 h-5 flex items-center justify-center"></i>
                Jelajahi Menu Kami
              </Button>
              <Button 
                variant="outline" 
                size="lg"
                onClick={() => scrollToSection('#reservation')}
                className="shadow-2xl shadow-yellow-500/50 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-calendar-line mr-2 w-5 h-5 flex items-center justify-center"></i>
                Reservasi Sekarang
              </Button>
            </div>
          </div>

          {/* Restaurant Image */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden border-4 border-red-500/30 shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/21939992022ebd742da351d515a6cdc1.jpg"
                alt="Interior TAKEYA Restaurant"
                className="w-full h-80 object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
            </div>
            
            {/* Floating Stats */}
            <div className="absolute -bottom-8 -left-8 bg-gradient-to-br from-red-600 to-red-700 rounded-2xl p-6 border border-red-400/30 shadow-2xl">
              <div className="text-center">
                <div className="text-3xl font-black text-white mb-1">100+</div>
                <div className="text-yellow-300 text-sm font-semibold">Menu Autentik</div>
              </div>
            </div>
            
            <div className="absolute -top-8 -right-8 bg-gradient-to-br from-yellow-600 to-yellow-700 rounded-2xl p-6 border border-yellow-400/30 shadow-2xl">
              <div className="text-center">
                <div className="text-3xl font-black text-white mb-1">5★</div>
                <div className="text-red-300 text-sm font-semibold">Rating Pelanggan</div>
              </div>
            </div>
          </div>
        </div>

        {/* Philosophy Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {philosophies.map((philosophy, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-sm rounded-3xl border border-red-500/20 p-8 text-center hover:transform hover:scale-105 hover:border-red-500/40 transition-all duration-300 group"
            >
              <div className={`w-16 h-16 bg-gradient-to-br ${
                philosophy.color === 'red' ? 'from-red-500 to-red-600' :
                philosophy.color === 'blue' ? 'from-blue-500 to-blue-600' :
                philosophy.color === 'yellow' ? 'from-yellow-500 to-yellow-600' :
                'from-green-500 to-green-600'
              } rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${philosophy.icon} text-white text-2xl w-8 h-8 flex items-center justify-center`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-white mb-2 group-hover:text-red-400 transition-colors">
                {philosophy.title}
              </h3>
              <p className="text-yellow-400 text-sm font-medium mb-4" style={{ fontFamily: '"Noto Sans JP", serif' }}>
                {philosophy.subtitle}
              </p>
              <p className="text-gray-300 text-sm leading-relaxed">
                {philosophy.description}
              </p>
            </div>
          ))}
        </div>

        {/* Stats Section */}
        <div className="mt-20 bg-gradient-to-r from-red-900/20 to-yellow-900/20 backdrop-blur-sm rounded-3xl border border-red-500/20 p-12">
          <div className="grid md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-4xl font-black text-red-400 mb-2">2024</div>
              <div className="text-white font-semibold mb-1">Tahun Berdiri</div>
              <div className="text-gray-400 text-sm">Restoran Jepang Futuristik</div>
            </div>
            <div>
              <div className="text-4xl font-black text-yellow-400 mb-2">50+</div>
              <div className="text-white font-semibold mb-1">Chef & Staff</div>
              <div className="text-gray-400 text-sm">Berpengalaman</div>
            </div>
            <div>
              <div className="text-4xl font-black text-green-400 mb-2">1000+</div>
              <div className="text-white font-semibold mb-1">Pelanggan Puas</div>
              <div className="text-gray-400 text-sm">Setiap Bulan</div>
            </div>
            <div>
              <div className="text-4xl font-black text-blue-400 mb-2">24/7</div>
              <div className="text-white font-semibold mb-1">Layanan Online</div>
              <div className="text-gray-400 text-sm">Pemesanan & Reservasi</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
